import { getParamfromUrl } from '../helpers';
import { ILogInput } from '../networked-shared-interfaces/constants/firebase-event-names';
import {
	identifyUser,
	trackEvent,
	trackEventNow,
	updateTenantSnapshot,
} from 'fe-shared-lib/src/analytics';

function readFirebaseTrackData(): Record<string, unknown> | null {
	if (typeof window === 'undefined') {
		return null;
	}
	try {
		const raw = localStorage.getItem('FirebaseData');
		if (!raw) {
			return null;
		}
		return JSON.parse(raw) as Record<string, unknown>;
	} catch {
		return null;
	}
}

/**
 * Legacy name: previously Firebase Analytics. Call sites are unchanged; events
 * route through `fe-shared-lib/src/analytics` (multi-tenant PostHog).
 */
export class FirebaseAnalytics {
	private static instance: FirebaseAnalytics;

	private constructor() {}

	static getInstance(): FirebaseAnalytics {
		if (!FirebaseAnalytics.instance) {
			FirebaseAnalytics.instance = new FirebaseAnalytics();
		}
		return FirebaseAnalytics.instance;
	}

	/**
	 * PostHog adds page url / host / screen size itself; plan replaces paid_user (person
	 * property via identifyUser). Only community_user_type survives from the old shim.
	 */
	private buildParams(x: ILogInput): Record<string, unknown> {
		const TrackData = readFirebaseTrackData();
		return {
			community_user_type: TrackData?.community_user_type,
			...(x.eventParams ? {...x.eventParams} : {}),
		};
	}

	logEvent = (x: ILogInput): void => {
		if (typeof window === 'undefined') {
			return;
		}
		try {
			trackEvent(x.eventName, this.buildParams(x));
		} catch {
			// Never throw from analytics-shaped logging
		}
	};

	/** Sent right away (beacon) for events fired just before a redirect, e.g. auth_logout. */
	logEventNow = (x: ILogInput): void => {
		if (typeof window === 'undefined') {
			return;
		}
		try {
			trackEventNow(x.eventName, this.buildParams(x));
		} catch {
			// Never throw from analytics-shaped logging
		}
	};

	setUserID = (userId: string | undefined): void => {
		if (!userId) {
			identifyUser(null);
			return;
		}
		identifyUser({userId});
	};

	setCommunityId = (communityId: string): void => {
		updateTenantSnapshot({communityId});
	};
}
